import React from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'

export default function ButtonTextCard (props) {
  const [fadeInRef, isInView] = useInView({ triggerOnce: true })
  const { button, link, target } = props

  const renderCardContent = items =>
    items.map(item => {
      const [slideUpRef, isInView] = useInView({ triggerOnce: true })
      return props.volunteer ? (
        <React.Fragment key={item.volunteer_column_heading}>
          <div
            ref={slideUpRef}
            className={`col-lg-4 animation involved-volunteer__column ${
              isInView ? 'slide-left' : ''
            }`}
          >
            <h3
              className='heading3'
              dangerouslySetInnerHTML={{
                __html: item.volunteer_column_heading
              }}
            />
            <div
              className='partner__info'
              dangerouslySetInnerHTML={{
                __html: item.volunteer_column_paragraph
              }}
            />
          </div>
          <style jsx>{`
            .partner {
              opacity: 0;
            }
          `}</style>
        </React.Fragment>
      ) : (
        <React.Fragment key={item.partner_link.url}>
          <div
            ref={slideUpRef}
            className={`col-10 col-lg-4 partner ${isInView ? 'slide-up' : ''}`}
          >
            <a
              className='link'
              href={item.partner_link.url}
              target={item.partner_link.target}
              rel={`${item.partner_link.target == '_blank' ? 'noopener' : ''}`}
            >
              {item.partner_name}
              <span className='sr-only'>
                {' '}
                external link opens in new window
              </span>
              <i className='fas fa-external-link-alt'></i>
            </a>

            <div
              className='partner__info'
              dangerouslySetInnerHTML={{ __html: item.partner_text }}
            />
          </div>
          <style jsx>{`
            .partner {
              opacity: 0;
            }
          `}</style>
        </React.Fragment>
      )
    })

  return (
    <React.Fragment>
      <div
        className={` row ${
          props.firstTier ? 'partners__tier1' : 'involved-volunteer__columns'
        }`}
      >
        <div className='col-10 col-lg-8 offset-1 offset-lg-2'>
          <div className='row '>{renderCardContent(props.content)}</div>
        </div>
      </div>

      {props.volunteer && link ? (
        <div className='row'>
          <div className='col-12'>
            <p className='text-center'>
              {target == '_blank' ? (
                <a href={link} className='link' target={target}>
                  {button}
                </a>
              ) : (
                <Link href={link} passHref>
                  <a className='link' target={target} rel='noopener'>
                    {button}
                  </a>
                </Link>
              )}
            </p>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}
